var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mainVisual"},[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"inner"},[_vm._t("default"),_c('div',{staticClass:"scroll"})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }